type Inline = { type: "text"; text: string } | { type: "link"; text: string };

function toInlineList(text: string) {
  const regex = /\b(http:\/\/|https:\/\/)([^\s()]|\([^\s()]*\))+/g;
  const result: Inline[] = [];
  let caret = 0;

  // NOTE: we set an upper bound to prevent an infinite loop,
  // despite that such case will never happen
  for (let i = 0; i < 1000; i++) {
    const matched = regex.exec(text);
    if (!matched) break;
    result.push({ type: "text", text: text.slice(caret, matched.index) });
    result.push({ type: "link", text: matched[0] });
    caret = matched.index + matched[0].length;
  }

  result.push({ type: "text", text: text.slice(caret) });
  return result.filter((item) => !!item.text);
}

export function toParagraphList(text: string): Inline[][] {
  return text.split("\n").map((line) => toInlineList(line));
}
